'use strict';

/* eslint no-inner-declarations: 0 */
define('components/header-carousel-offers',[
  'jquery',
  'lib/util/tda.config',
  'lib/tda/all',
  'responsive',
  'ajaxOffers',
  'bxStrip',
  'lib/getParameterByName',
  'lib/util/langFromUrl',
  'lib/analytics/click',
  'lib/analytics/click.manual',

  // side effect includes
  'Handlebars',
  'bat',
  'lazyload'
], function (
  $,
  tdaConfig,
  tdaAll,
  responsive,
  AjaxOffers,
  BxStrip,
  getParameterByName,
  langFromUrl,
  anClicks,
  anClickManual
) {
  var carouselOffersHeader = {
    load: function (el) {
      var self = this;
      self.$el = $(el);
      var isHeaderExpanded = false;
      var $offersHeader = $('.js-offers-header', self.$el);

      function openCarousel() {
        if (!$('#disable-expansion').length) {
          var $header = $('.js-offers-header.carousel-header-mini');
          var $mini = $header.find('.minified');
          var $full = $header.find('.full');
          var $carouselHeaderBackgrounds = $('.carousel-header-backgrounds');
          // BAT-3193 Fade in images on every collapse/expand
          $carouselHeaderBackgrounds.fadeIn(500, function () {
          });


          if ($header.hasClass('is-minified')) {
            // expand
            $header.css({
              height: $mini.height()
            });
            $full.show();
            $('#header-expand-button-inner').addClass('active');

            $header.animate({
              height: $full.height()
            }, 300, function () {
              $header.removeClass('is-minified').addClass('is-expanded');

              $mini.hide();
              $header.css('height', 'auto');
            });

            $mini.animate({
              top: $mini.height() * -1,
              opacity: 0.5
            }, 300);

            $full.animate({
              top: $mini.height() * -1,
              opacity: 1
            }, 300, function () {
              $full.css({
                top: 0
              });
            });

            isHeaderExpanded = true;
            $('#header-expand-button-outer').addClass('deactivate');
            // only build if it has not previously been built already
            var isAlreadyBuilt = $header.find('.bx-wrapper').length;
            if (!isAlreadyBuilt) {
              carouselOffersHeader.buildCarousel();
            } else {
              // var foo = carouselOffersHeader.currentCarousel;
              // carouselOffersHeader.currentCarousel.reloadSlider();
            }

            hideExpandButton(); // do we need this?
          }
        }
      }

      function closeCarousel() {
        var $header = $('.js-offers-header.carousel-header-mini').not('[data-slide]');
        var $mini = $header.find('.minified');
        var $full = $header.find('.full');
        var $carouselHeaderBackgrounds = $('.carousel-header-backgrounds');

        if ($header.hasClass('is-expanded')) {
          // minify
          $header.css({
            height: $full.height()
          });

          $mini.show();
          $full.css({
            top: $mini.height() * -1
          });
          $('#header-expand-button-inner').removeClass('active');

          $header.animate({
            height: $mini.height()
          }, 300, function () {
            $header.removeClass('is-expanded').addClass('is-minified');
            $full.hide();
            $header.css('height', 'auto');
          });

          // remove our DOM element that has all the BG images
          $carouselHeaderBackgrounds.fadeOut(500, function () {
          });

          $mini.animate({
            top: 0,
            opacity: 1
          }, 300).fadeTo();

          $full.animate({
            top: 0,
            opacity: 0.5
          }, 300, function () {
          });

          isHeaderExpanded = false;
        }
      }

      if ($offersHeader.length) {
        self.init();
        anClicks(self.$el);

        // BAT-2163 Open a collapsed carousel
        $('.js-header-carousel-show-hide').not('.js-header-carousel-show-hide.active').on('click', function () {
          var $this = $(this);
          var ariaLabel = '';
          if ($this.hasClass('active')) {
            ariaLabel = langFromUrl() === 'es' ? 'Agrandar cartel' : 'Expanding banner';
            closeCarousel();
          } else {
            ariaLabel = langFromUrl() === 'es' ? 'Reducir cartel' : 'Collapsing banner';
            anClickManual(self.$el, $this);
            openCarousel();
          }
          $('#expander').attr('aria-label', ariaLabel);
        });

        function hideExpandButton() {
          $('#header-expand-button-inner').stop().animate({
            width: 18
          }, 200, function () {
            $('#header-expand-button-expand').hide();
          });
        }

        $('.js-offers-header #header-expand-button-outer').off('mouseover'); // remove event that is attached via old click button
        $('.js-offers-header').off('mouseover').on('mouseover', function () {
          if (!isHeaderExpanded) {
            $('#header-expand-button-expand').show();
            var expandWidth = $('#header-expand-button-expand').outerWidth(true);
            var plusWidth = $('#header-expand-button-plus').outerWidth(true);

            $('#header-expand-button-inner').stop().animate({
              width: (expandWidth + plusWidth)
            }, 200);
          }
        }).off('mouseout').on('mouseout', function () {
          if (!isHeaderExpanded) {
            hideExpandButton();
          }
        });
      }
    },

    init: function () {
      /* if our header is collapsed by default
        - we need to see which masthead to use (if multiple exist)
        - we do NOT need to getOffers by default */
      if (this.headerCollapsedByDefault()) {
        var mastheadArr = this.getVehicleSpecificMastheads();
        var result;
        // if we have an array of mastheads, we need to see which one to use
        if (mastheadArr.length >= 1) {
          // find the series that is present in the DOM of the page we're on, if any
          var curPageSeries = this.getPageBasedSeries().toString();
          // Toss into an array, to handle offers that contain multiple series (we need to find the first masthead)
          curPageSeries = curPageSeries.split(',');
          if (curPageSeries.length > 0) {
            // if we have a curPageSeries;
            for (var i = 0; i < curPageSeries.length; i++) {
              // get the first (in case there are more than one) item, from the mastheadArr whose obj contains curPageSeries
              result = mastheadArr.filter(function (obj) {
                if (obj.series === curPageSeries[i]) {
                  return curPageSeries[i];
                }
              })[0];
              if (result) {
                break;
              }
            }
            // if we don't have a result, use the first item
            if (!result) {
              result = mastheadArr[0];
            }
          } else {
            // else, just get the first
            result = mastheadArr[0];
          }
          // now build our collapsed masthead using this specific masthead data
          this.buildVehicleSpecificMasthead(result);
        }
      }
      // this is because ajax-offers.js relies on it!
      carouselOffersHeader.getCarouselOffers();
      this.headerExpanderAda();
    },

    headerCollapsedByDefault: function () {
      // if our header has a class of 'carousel-header-mini', then it was/is closed by default
      var isMini = $('.js-offers-header').hasClass('carousel-header-mini');
      return isMini;
    },

    // BAT-4718 ADA.
    updateCarouselArrows: function () {
      var sns = langFromUrl() === 'es' ? 'Ver siguente diapositiva' : 'Show Next Slide';
      var sps = langFromUrl() === 'es' ? 'Ver diapositiva anterior' : 'Show Previous Slide';
      $('.carousel-next button').attr('tabIndex', '0').attr('aria-label', sns);
      $('.carousel-prev button').attr('tabIndex', '0').attr('aria-label', sps);
    },

    ctaLinksOnTeamSitePreview: function () {
      // for use on preview only
      // make all CTA's 'unclickable' in TeamSite preview.
      // Note: this must be invoked after HandleBars updates carousel template (happens when there's offers in carousel)
      var isTeamSitePreview = window.location.href.indexOf('teamsite') > -1;
      if (isTeamSitePreview) {
        /*----------------------------------------------------------------
        Attach click events to the following:
          - Desktop slide CTAs $('#js-slide-cta .cta-content a')
          - Desktop AND mobile fullcanvas links #('.js-offers-header a.carousel-header-fullcanvas-link')
          - Mobile slide CTAs $('.cta-content-wrap.hidden-md a');
        ----------------------------------------------------------------*/
        var ctaAnchors = $('#js-slide-cta .cta-content a,  .js-offers-header a.carousel-header-fullcanvas-link, .js-offers-header .cta-content-wrap.hidden-md a');
        $(ctaAnchors).on('click', function (e) {
          var href = $(this).attr('href');
          e.preventDefault();
          alert('CTA is not available on preview for destination: ' + href);
        });
      }
    },

    getCarouselOffers: function () {
      var $offersHeader = $('.js-offers-header');
      // get each carousel item that contains a data-offerid attribute
      var $itemsWithOffers = $offersHeader.find('div[data-offerid]').not('.bx-clone');
      // a carousel MAY NOT contain offers. If not, just build the carousel and end
      if ($itemsWithOffers.length === 0) {
        if ($offersHeader.hasClass('header-is-open')) {
          carouselOffersHeader.buildCarousel();
        }
        return;
      }

      // Build string of offerId's
      var offerIdsString = '';
      var tmpOffersFound = [];
      $.each($itemsWithOffers, function () {
        // removing _es from offerId as offers service uses lang parameter no <offer_id>_es
        var tmpOfferId = $(this).data('offerid').toString().replace(/_es$/, ''); // note: we now remove _es from output in the XSL file
        // Prevent duplicate offerId's in our offerstring
        if (tmpOffersFound.indexOf(tmpOfferId) === -1) {
          tmpOffersFound.push(tmpOfferId);
          offerIdsString += '&offerId=' + tmpOfferId;
        }
      });
      /*--------------------------------------------------------------------
      GET OFFERS
      We still need to pass it our template to AjaxOffers, even though we won't actually use it ($('#template-offer-header-item'))
      AjaxOffers was previously built for use with isotope,
      where we can render a big block of HTML, instead of individual pieces.
      In this case though, we need to render individual pieces
      --------------------------------------------------------------------*/
      var offersHeaderAjax = new AjaxOffers('/offers-service/OFFERS/byOfferId?pageSize=5' + offerIdsString, true, true, $('#template-offer-header-item'), false, false);
      offersHeaderAjax.init();

      // no offers found in offers service, just build the carousel (if our header is open)
      $(offersHeaderAjax).on('NO_ITEMS_FOUND', function () {
        if ($offersHeader.hasClass('header-is-open')) {
          carouselOffersHeader.buildCarousel();
        }
      });

      $(offersHeaderAjax).on('COMPLETE', function (event, $newItems, data) {
        var validOffersDisplaying = [];
        // for each item, render to proper spot on DOM, using the handlebars template
        for (var i = 0; i < data.items.length; i += 1) {
          var validOffer = data.items[i].id;
          validOffersDisplaying.push(validOffer);
          var indyOfferTemplate = $('#template-offer-header-item').html();
          var itemForHandblebars = { items: [data.items[i]] };
          var indyOfferHtml = Handlebars.hcompile(indyOfferTemplate, itemForHandblebars);
          // Update the HTML of the appropriate 'slide' (the one with the matching data-offerid)
          $('div[data-offerid="' + data.items[i].id + '"]').find('.cta-content').html(indyOfferHtml);
        }

        /*--------------------------------------------------------------------
        IF NO OFFER FOR OFFERID (likely, it's an expired offer)
        // If data for an offer isn't returned, then it doesn't exist in the offers service
        // so, we push all offers that ARE used to an array (validOffersDisplaying, above), and for those inline offer-id's
        // that are NOT in our array, we display the default block of copy
        // NOTE: we are NOT yet accounting for when validOffersDisplaying.length = 0
        // also note: we may not need to do ANYTHING at all with an invalid offer, since we display default copy
        --------------------------------------------------------------------*/
        $.each($itemsWithOffers, function () {
          var curId = $(this).data('offerid');
          if (validOffersDisplaying.indexOf(curId) === -1) {
            $('div[data-offerid="' + curId + '"]').addClass('is-invalid-offer');
          }
        });

        if ($offersHeader.hasClass('header-is-open')) {
          carouselOffersHeader.buildCarousel();
        }
      });
    },

    getVehicleSpecificMastheads: function () {
      // get all mastheads, turn them into an array of objects
      var initMastheadArr = $('.js-masthead');
      var finalMastheadArr = [];
      for (var i = 0; i < initMastheadArr.length; i++) {
        var $curMasthead = $(initMastheadArr[i]);
        var dataAsString = $curMasthead.data('masthead');
        var tmpArr = dataAsString.split('|');
        var tempObj = {
          series: tmpArr[0],
          disableExpansion: tmpArr[1],
          imageMastheadCollapsed: tmpArr[2],
          imageMastheadMobileCollapsed: tmpArr[3],
          imageMastheadCollapsedAlttext: tmpArr[4],
          ImageMastheadDestination: tmpArr[5]
        };
        finalMastheadArr.push(tempObj);
      }
      return finalMastheadArr;
    },

    buildVehicleSpecificMasthead: function (curVehicleMasthead) {
      var $newMastheadBackground = $('.js-offers-header').children('.minified');
      var $newMastheadMobile = $newMastheadBackground.children('img');
      var newMastheadBackgroundImg = tdaAll.localImgPath(curVehicleMasthead.imageMastheadCollapsed);
      var newMastheadExpandDisabled = curVehicleMasthead.disableExpansion;
      var newMastheadDestination = curVehicleMasthead.ImageMastheadDestination;
      var $mastheadDestinationAnchor = $newMastheadBackground.children('a');

      // if disable expansion is true, hide the expander
      if (newMastheadExpandDisabled === 'true') {
        $('.js-offers-header').addClass('expand-is-disabled');
      }

      // Update masthead BG image, only on md and lg!
      if (responsive() !== 'sm') {
        $newMastheadBackground.css({
          'background-image': 'url(' + newMastheadBackgroundImg + ')'
        });
      } else {
        $newMastheadMobile.lazy({
          bind: 'event',
          delay: 0,
          afterLoad: function ($el) {
            $el.removeClass('hidden-sm hidden-md');
          }
        });
      }

      // update or remove the masthead destination link
      if (newMastheadDestination) {
        var customUrlArr = newMastheadDestination.split('/'); // split it into an array, so we can drop the unused parts
        if (customUrlArr[1] == 'sites') {
          customUrlArr.splice(0, 3); // Drop the first 3 items from array ('', 'sites', 'TDA')
          customUrlArr.unshift('/' + tdaConfig.site.context_url);
        }
        var finalUrl = customUrlArr.join('/'); // create URL from array

        if (finalUrl.length > 0) {
          $mastheadDestinationAnchor.attr('href', finalUrl);
        } else {
          $mastheadDestinationAnchor.remove();
        }
      } else {
        $mastheadDestinationAnchor.remove();
      }
    },

    /*---------------------------------------------------------------------------
    BAT-2440: we need this to determine which item in our mastheadArr to display
    get current vehicle from the following pages:
    - Offer Detail page
    - Vehicle Info page
    - Simplified Comparison page
    - Inventory Detail page
    - Vehicle Offers page
    ---------------------------------------------------------------------------*/
    getPageBasedSeries: function () {
      // Offer Detail pages
      // test URLs:
      // http://test.newengland.aws.buyatoyota.com/en/offer-detail/?offerid=camry_cash_1458153005263 (testcarousel6)
      // http://test.newengland.aws.buyatoyota.com/en/offer-detail/?offerid=rav4_lease_1458153007902 (testcarousel6)
      if ($('div#offer-detail').length) {
        var offerSeries = $('div#offer-detail').data('series');
        if (offerSeries === 'multi') {
          offerSeries = $('div#offer-detail').data('series-all');
        }
        return offerSeries;

      // vehicle info
      // test URL: http://test.newengland.aws.buyatoyota.com/en/vehicles/priusc/ (testcarousel6)
      // http://test.newengland.aws.buyatoyota.com/en/vehicles/prius/
      // http://test.newengland.aws.buyatoyota.com/en/vehicles/camryhybrid/
      // http://test.newengland.aws.buyatoyota.com/en/vehicles/highlander/ (testcarousel6, no highlander masthead)
      // http://test.newengland.aws.buyatoyota.com/en/vehicles/avalon/ (testcarousel5, sample of older format (single masthead))
      }
      if ($('div#page-vehicle-info').length) {
        return $('div#page-vehicle-info').data('series').toString();

      // simplified comparison page
      // test URLs: http://test.newengland.aws.buyatoyota.com/en/compare/16-rav4-escape.page (testcarousel6)
      }
      if ($('#vehicle-compare-offer').length) {
        return $('#vehicle-compare-offer').attr('series');

      // Inventory detail page (and inventory search results)
      // test URL: http://test.newengland.aws.buyatoyota.com/en/inventory-detail/?vehicleid=BRD_TOY-YR_2017-MDL_3544-XCOL_0218-ICOL_LD20-ACY+XL-ACY+2T-PKG+FE&series=avalon
      // all Inventory Detail pages use  (testcarousel6)
      // TODO: inv detail page DOM is not updated in time for this.
      }
      if ($('#inventory-detail').length) {
        // return $('#inventory-detail').data('series');
        return getParameterByName('series');

      // Offers vehicle page
      // test URLs: http://test.newengland.aws.buyatoyota.com/en/offers/corolla/ (testcarousel6)
      // http://test.newengland.aws.buyatoyota.com/en/offers/rav4/ (testcarousel6)
      }
      if ($('#offers-vehicle-page').length) {
        return $('#offers-vehicle-page').data('series');
      }
      return '';
    },

    buildCarousel: function () {
      var self = this;
      var $carouselNext = $('.carousel.carousel-header-offers .carousel-next');
      var $carouselPrev = $('.carousel.carousel-header-offers .carousel-prev');
      var slideCount = $('.carousel-header-offers.full .item').length - 1;

      $carouselNext.off().on('click', function () {
        var curSlide = carouselOffersHeader.currentCarousel.getCurrentSlide();
        if (curSlide === slideCount) {
          carouselOffersHeader.currentCarousel.goToSlide(0, 'prev');
        }
      });

      $carouselPrev.off().on('click', function () {
        var curSlide = carouselOffersHeader.currentCarousel.getCurrentSlide();
        if (curSlide === 0) {
          carouselOffersHeader.currentCarousel.goToSlide(slideCount, 'next');
        }
      });

      carouselOffersHeader.ctaLinksOnTeamSitePreview();

      // if there's only one slide, then slideCount will be 0!
      if (slideCount === 0) {
        var $contentWrap = $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap');
        var firstSlideBgSingle = $('.carousel-header-offers.full .item').data('bgimg');
        $('.carousel-header-backgrounds').remove();
        $('.js-offers-header').prepend('<div class="carousel-header-backgrounds"></div>');
        $contentWrap.css('opacity', 1);

        if (responsive() === 'md' && !$('html').hasClass('tablet')) {
          $('.mobile-fullcanvas').addClass('visible-md');
        }

        if (responsive() === 'lg') {
          $('.carousel-header-backgrounds').css({
            'background-image': 'url(' + firstSlideBgSingle + ')'
          });
          // only a one slide, so we never get our lazy loading FG img from onSliderLoad. Do that here
          self.lazyLoadImages($('.carousel-header-offers.full .item').eq(0).find('.full-height-md'));
        }
      }

      function doCarousel() {
        var headerOffers = new BxStrip({
          $component: $('.carousel.carousel-header-offers'),
          $slider: $('.carousel-header-offers .carousel-inner'),
          bxoptions: {
            desktop: {
              waitForImageLoad: false,
              adaptiveHeight: true,
              auto: true,
              autoStart: false,
              pause: 6000,
              useCSS: true,
              pager: true,
              infiniteLoop: false,
              onSliderLoad: function (index) {
                var firstSlideBg = $('.carousel-header-offers.full .item').eq(index).data('bgimg');
                var $firstSlideForeground = $('.carousel-header-offers.full .item').eq(index).find('.full-height-md');
                $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap').css('opacity', 0).attr('style', '');
                $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap').eq(index).css('opacity', 1);
                $('.carousel-header-backgrounds').remove();
                $('.js-offers-header').prepend('<div class="carousel-header-backgrounds"></div>');
                $('.carousel-header-backgrounds').css({
                  'background-image': 'url(' + firstSlideBg + ')'
                });
                self.lazyLoadImages($firstSlideForeground);

                // BAT-4718
                carouselOffersHeader.updateCarouselArrows();
                // ADA BAT-3997 ADD INDEXES TO CTA so we can hide them later.
                carouselOffersHeader.prepareCarouselForADA(index);
                carouselOffersHeader.handleFullCanvasLinks(index);
              },

              onSlideBefore: function ($el, prevIndex, nextIndex) {
                self.lazyLoadImages($el.find('.full-height-md'));
                $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap').eq(prevIndex).css('opacity', 0);
                $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap').eq(nextIndex).css('opacity', 1);
                $el.css('display', 'block');
                var slideBg = $($el).data('bgimg');
                $('.carousel-header-backgrounds').css({
                  'background-image': 'url(' + slideBg + ')'
                });
              },

              onSlideAfter: function ($el, prevIndex, newIndex) {
                // ADA BAT-3997 make none visible cta's non tabbable.
                carouselOffersHeader.hideInactiveCarouselSlides(newIndex);
                carouselOffersHeader.handleFullCanvasLinks(newIndex);
              },
              nextSelector: '.carousel-next',
              prevSelector: '.carousel-prev'
            },

            tablet: {
              waitForImageLoad: false,
              adaptiveHeight: false,
              auto: true,
              autoStart: false,
              pause: 6000,
              useCSS: true,
              pager: true,
              infiniteLoop: true,
              onSliderLoad: function (index) {
                var $slideContentMobile = $('#js-slide-cta').detach();
                $('.carousel-header-offers').find('.bx-viewport').prepend($slideContentMobile);
                $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap').css('opacity', 0).attr('style', '');
                $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap').eq(index).css('opacity', 1);
                $('.js-offers-header').prepend('<div class="carousel-header-backgrounds"></div>');
                carouselOffersHeader.prepareCarouselForADA(index);
                carouselOffersHeader.handleFullCanvasLinks(index);
              },
              onSlideBefore: function ($el, prevIndex, nextIndex) {
                $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap').eq(prevIndex).css('opacity', 0);
                $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap').eq(nextIndex).css('opacity', 1);
                $el.css('display', 'block');
                self.lazyLoadImages($el);
                var mfc = $('.mobile-fullcanvas');
                mfc.each(function (index, item) {
                  if ($('html').hasClass('portrait') && $('html').hasClass('tablet')) {
                    $(item).addClass('show-tablet');
                  }
                  if ($('html').hasClass('landscape') && $('html').hasClass('tablet')) {
                    $(item).removeClass('show-tablet');
                  }
                  if (responsive() === 'md' && !$('html').hasClass('tablet')) {
                    $(item).addClass('visible-md');
                  }
                });
                // BAT-3129 REMOVE POINTER EVENTS FROM ALL SLIDES
                $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap').css('pointer-events', 'none');
              },
              onSlideAfter: function ($el, prevIndex, newIndex) {
                $el.css('display', 'block');
                // BAT-3129 add click to active slide.
                $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap').eq(newIndex).css('pointer-events', 'all');
                // ADA BAT-4358 make none visible cta's non tabbable.
                carouselOffersHeader.hideInactiveCarouselSlides(newIndex);
                carouselOffersHeader.handleFullCanvasLinks(newIndex);
              },
              nextSelector: '.carousel-next',
              prevSelector: '.carousel-prev'
            },

            phone: {
              waitForImageLoad: false,
              adaptiveHeight: false,
              auto: false, // BAT-4358 changed to false
              autoStart: false,
              pause: 6000,
              useCSS: true,
              pager: true,
              infiniteLoop: true,
              onSliderLoad: function (index) {
                var bxViewportHeight = $('.carousel-header-offers').find('.bx-viewport').height();
                var $slideContentMobile = $('#js-slide-cta').detach();
                $('.carousel-header-offers').find('.bx-viewport').css({ 'min-height': (bxViewportHeight + 40) }).prepend($slideContentMobile);
                $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap').css('opacity', 1).attr('style', '');
                $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap').eq(index).css('opacity', 1);
                $('.carousel-header-backgrounds').remove();
                $('.js-offers-header').prepend('<div class="carousel-header-backgrounds"></div>');
                carouselOffersHeader.prepareCarouselForADA(index);
              },
              onSlideBefore: function ($el, prevIndex, nextIndex) {
                self.lazyLoadImages($el);
                $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap').eq(prevIndex).css('opacity', 0);
                $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap').eq(nextIndex).css('opacity', 1);
                $el.css('display', 'block');
                // BAT-2778 REMOVE POINTER EVENTS FROM ALL SLIDES.
                $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap').each(function (index, item) {
                  $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap').eq(index).css('pointer-events', 'none');
                });
              },
              onSlideAfter: function ($el, prevIndex, newIndex) {
                $el.css('display', 'block');
                // BAT-2778 ADD POINTER EVENTS TO CURRENT SLIDE.
                $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap').eq(newIndex).css('pointer-events', 'all');
                carouselOffersHeader.hideInactiveCarouselSlides(newIndex);
              },
              nextSelector: '.carousel-next',
              prevSelector: '.carousel-prev'
            }
          }
        }, true);
        carouselOffersHeader.currentCarousel = headerOffers.slider;
      }

      if (responsive() !== 'lg') {
        // load the first img of mobile, needs to happen before our slideshow is built
        $('img.lazy-not-lg', '.carousel-header-offers .item.active').lazy({
          bind: 'event',
          delay: 0,
          afterLoad: function ($el) {
            $el.removeClass('hidden-sm hidden-md');
            doCarousel();
          }

        });
      } else {
        doCarousel();
      }
    },

    lazyLoadImages: function ($scope) {
      if (responsive() !== 'lg') {
        $('img.lazy-not-lg', $scope).lazy({
          bind: 'event',
          delay: 0,
          afterLoad: function ($el) {
            $el.removeClass('hidden-sm hidden-md');
          }
        });
      } else {
        $('img.lazy', $scope).lazy({
          bind: 'event',
          delay: 0,
          afterLoad: function ($el) {
            $el.removeClass('hidden-sm hidden-md hidden-lg');
          }
        });
      }
    },

    handleFullCanvasLinks: function (index) { // BAT-4781
      // FULL CANVAS LINKS NEED TO BE HIDDEN. ONLY VISIBLE SLIDES WITH THIS FULL CANVSAS LINK SHOULD BE ACCESIBLE.
      $('.carousel-header-offers').find('.carousel-header-fullcanvas-link').each(function (idx, item) {
        $(item).attr('tabIndex', '-1');
      });
      // $('.carousel-header-offers.full .item').eq(index).find('.carousel-header-fullcanvas-link').css('border', '1px solid green');
      $('.carousel-header-offers.full .item').eq(index).find('.carousel-header-fullcanvas-link').attr('tabIndex', '0');
    },

    prepareCarouselForADA: function (index) {
      setTimeout(function () { // BAT-4358
        // $('.carousel-header-offers ').find('.carousel-header-fullcanvas-link').attr('tabIndex', '-1');
        var ctas = $('#js-slide-cta .cta-content-wrap');
        ctas.each(function (slideIndex, item) {
          $(item).attr('data-index', slideIndex);
          if (slideIndex === index) {
            // $(item).attr('tabIndex', '0');
            $(item).show();
          } else {
            // $(item).attr('tabIndex', '-1');
            $(item).hide();
          }
        });
        $('.bx-pager-link').each(function (idx, item) {
          var totalSlides = $('.bx-pager-link').length;
          var slideNum = idx + 1;
          var alabel = 'show slide ' + slideNum + ' of ' + totalSlides;
          if (langFromUrl() === 'es') alabel = 'muestra la diapositiva ' + slideNum + ' de ' + totalSlides;
          $(item).attr('aria-label', alabel).attr('role', 'button');
        });
      }, 500);
    },

    hideInactiveCarouselSlides: function (newIndex) {
      // ADA BAT-4358 make none visible cta's non tabbable.
      var ctas = $('#js-slide-cta .cta-content-wrap');
      ctas.each(function (slideIndex, item) {
        var dinum = Number($(item).attr('data-index'));
        if (dinum === newIndex) {
          // $(item).attr('tabIndex', '0');
          $(item).show();
        } else {
          // $(item).attr('tabIndex', '-1');
          $(item).hide();
        }
      });
    },

    headerExpanderAda: function () {
      // $('#header-expand-button').on('keyup', function (event) {
      $('#expander').on('keyup', function (event) {
        if (event.keyCode === 32 || event.keyCode === 13) {
          $('.js-header-carousel-show-hide').trigger('click');
          event.preventDefault();
        }
      });
    },

    // store carousel selector here, so we can use .destroySlider() later
    currentCarousel: []
  };

  return carouselOffersHeader;
});

